import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MedicoService } from 'src/app/shared/servicio/medico/medico.service';
import { FormControl, Validators } from '@angular/forms';
import { DashboardComponent } from '../../dashboard/dashboard.component';
import { HelpersService } from '../../../shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-realizar-encuesta',
  templateUrl: './realizar-encuesta.component.html',
  styleUrls: ['./realizar-encuesta.component.css'],
})
export class RealizarEncuestaComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private _medic: MedicoService,
    public dash: DashboardComponent,
    private helper: HelpersService
  ) { }

  surveyId;
  survey_data;

  questionIds;
  questions;
  answers;
  questionFormControls;
  sentMessage;

  // Propiedades para manejar tipos de preguntas
  questionTypes = {}; // Para almacenar el tipo de cada pregunta
  openAnswers = {}; // Para almacenar respuestas de preguntas abiertas

  loading: boolean;
  sent: boolean;
  dataLista = false;

  preloader: boolean = false;

  // Mantener radio para preguntas cerradas
  radio = [];

  ngOnInit() {
    this.loading = true;
    this.sent = false;
    this.route.params.subscribe((data) => {
      this.surveyId = data.id;
      this._medic.verEncuesta(this.surveyId).subscribe((data) => {
        this.survey_data = data;
        console.log('Datos de encuesta:', data);

        // Inicializar estructuras de datos
        this.initializeDataStructures();

        // Procesar preguntas
        this.processQuestions();

        this.loading = false;
      });
    });
  }

  /**
   * Inicializa las estructuras de datos
   */
  private initializeDataStructures() {
    this.questionIds = [];
    this.questions = {};
    this.questionTypes = {};
    this.openAnswers = {};
    this.questionFormControls = {};
    this.answers = {};
    this.radio = [];
  }

  /**
   * Procesa las preguntas de la encuesta
   */
  private processQuestions() {
    this.survey_data.body.forEach((element) => {
      const questionId = element.question.id;
      const questionType = element.question.question_type || 'closed';

      console.log(`Procesando pregunta ${questionId}: tipo ${questionType}`);

      // Datos básicos de la pregunta
      this.questionIds.push(questionId);
      this.questions[questionId] = element.question.question;
      this.questionTypes[questionId] = questionType;

      if (questionType === 'open') {
        // *** PREGUNTA ABIERTA ***
        console.log(`Pregunta ${questionId} es abierta`);

        // Form control para textarea
        this.questionFormControls[questionId] = new FormControl('', Validators.required);

        // Inicializar respuesta abierta
        this.openAnswers[questionId] = '';

        // NO agregar a radio array
        this.answers[questionId] = []; // Array vacío para preguntas abiertas

      } else {
        // *** PREGUNTA CERRADA/CATEGORIZADA (lógica original) ***
        console.log(`Pregunta ${questionId} es cerrada/categorizada`);

        // Mantener lógica original para preguntas cerradas
        this.radio.push({ questionID: questionId, answer: -1 });

        this.questionFormControls[questionId] = new FormControl('', Validators.required);
        this.answers[questionId] = [];

        // Procesar respuestas múltiples
        element.answers.forEach((ans) => {
          this.answers[questionId].push({
            id: ans.id,
            answer: ans.answer,
          });
        });
      }

      this.dataLista = true;
    });

    console.log('Radio array (preguntas cerradas):', this.radio);
    console.log('Tipos de preguntas:', this.questionTypes);
  }

  /**
   * Verifica si una pregunta es abierta
   */
  isOpenQuestion(questionId: any): boolean {
    return this.questionTypes[questionId] === 'open';
  }

  /**
   * Verifica si una pregunta es cerrada o categorizada
   */
  isClosedQuestion(questionId: any): boolean {
    const type = this.questionTypes[questionId];
    return type === 'closed' || type === 'categorized' || !type; // Por compatibilidad con encuestas sin tipo
  }

  /**
   * Maneja cambios en respuestas abiertas
   */
  onOpenAnswerChange(questionId: any, value: string) {
    console.log(`Respuesta abierta cambiada para pregunta ${questionId}:`, value);
    this.openAnswers[questionId] = value;
  }

  /**
   * Validación mejorada que incluye preguntas abiertas
   */
  isValid(radioArr) {
    // Validar preguntas cerradas (lógica original)
    let closedQuestionsInvalid = 0;
    for (let i = 0; i < radioArr.length; i++) {
      if (radioArr[i]['answer'] < 0) {
        closedQuestionsInvalid++;
      }
    }

    // Validar preguntas abiertas
    let openQuestionsInvalid = 0;
    for (let questionId of this.questionIds) {
      if (this.isOpenQuestion(questionId)) {
        const answer = this.openAnswers[questionId];
        if (!answer || answer.trim() === '') {
          openQuestionsInvalid++;
          console.log(`Pregunta abierta ${questionId} sin respuesta`);
        }
      }
    }

    const isValid = closedQuestionsInvalid === 0 && openQuestionsInvalid === 0;
    console.log('Validación:', {
      closedQuestionsInvalid,
      openQuestionsInvalid,
      isValid
    });

    return isValid;
  }

  /**
   * Envío con nuevo formato de API
   */
  enviar() {
    var data = {
      survey_id: this.surveyId,
      responses: [], // Cambio: "answers" -> "responses"
    };

    // Agregar respuestas de preguntas cerradas y categorizadas
    this.radio.forEach((element) => {
      const questionType = this.questionTypes[element.questionID] || 'closed';

      data.responses.push({
        question_id: element.questionID,
        question_type: questionType, // Nuevo: incluir tipo de pregunta
        answer_id: element.answer,
      });
    });

    // Agregar respuestas de preguntas abiertas
    for (let questionId of this.questionIds) {
      if (this.isOpenQuestion(questionId)) {
        const openAnswer = this.openAnswers[questionId];
        if (openAnswer && openAnswer.trim() !== '') {
          data.responses.push({
            question_id: questionId,
            question_type: 'open', // Nuevo: incluir tipo de pregunta
            response_text: openAnswer.trim(), // Nuevo: usar "response_text" en lugar de "open_answer"
            // NO incluir answer_id para preguntas abiertas
          });
        }
      }
    }

    console.log('Datos a enviar (nuevo formato):', data);

    if (this.isValid(this.radio)) {
      this.preloader = true;
      // CAMBIO: usar el nuevo método del servicio
      this._medic.enviarEncuesta(data).subscribe(
        (resp) => {
          console.log('Respuesta del servidor:', resp);
          this.helper.modalSuccess('¡Encuesta finalizada!');
          this.dash.user();
          this.dash.notification();
          this.sent = true;
          this.preloader = false;
        },
        (error) => {
          this.preloader = false;
          console.log('Error al enviar:', error);
          this.helper.modalError('¡Ya habías respondido esta encuesta!');
          this.sent = true;
        }
      );
    } else {
      this.helper.modalError(
        '¡Debes responder todas las preguntas del cuestionario!'
      );
    }
  }

  /**
   * Manejo de respuestas cerradas (lógica original mantenida)
   */
  test(rest, pregunt) {
    this.radio.forEach((element) => {
      if (element.questionID == pregunt) {
        element.answer = rest;
      }
    });
    console.log('Radio actualizado:', this.radio);
  }
}
